import { render, staticRenderFns } from "./ListFriend.vue?vue&type=template&id=2706bca1&scoped=true&"
import script from "./ListFriend.vue?vue&type=script&lang=js&"
export * from "./ListFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706bca1",
  null
  
)

export default component.exports